import { Avatar, Badge, makeStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import React, { useEffect, useRef } from "react";
import { memo } from "react";
import { useMemo } from "react";

const OnlineBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: "#44b700",
    color: "#44b700",
    /*     boxShadow: `0 0 0 2px ${theme.palette.background.paper}`, */
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "$ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  dot: {
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    border: "2px solid #fff",
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}))(Badge);

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  root: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: "100%",
    borderBottom: "1px solid gainsboro",
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  online: {
    background: "#44b700",
  },
  offline: {
    background: "orangered",
  },
}));

export const ChatAvatar = memo(({ primaryColor, children, secondaryColor, target, clientKey, connectionList = [], orderList = [], border = undefined, hideOnlineBadge = false }) => {
  const person = useMemo(() => {
    return orderList.find((c) => c.badgeNo == target);
  }, [target, orderList]);

  const online = useMemo(() => {
    return connectionList.find((c) => c.clientKey == target) || clientKey == target;
  }, [connectionList]);

  const avatarStyle = {
    background: primaryColor || "initial",
    color: secondaryColor || "initial",
    border,
  };
  return online && !hideOnlineBadge ? (
    <OnlineBadge
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      overlap="circular"
      variant="dot"
    >
      <Avatar src={person?.profileImage} style={avatarStyle} className="chat-avatar">
        {children}
      </Avatar>
    </OnlineBadge>
  ) : (
    <Avatar src={person?.profileImage} style={avatarStyle} className="chat-avatar">
      {children}
    </Avatar>
  );
});
